import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Card from '../Card';

export default function TimelineChart({ timeline, loading }) {
  if (loading) {
    return (
      <Card>
        <h2 className="card-title">Timeline (Last 30 Days)</h2>
        <div style={{ padding: 'var(--spacing-lg)', textAlign: 'center', color: 'var(--text-secondary)' }}>
          Loading timeline data...
        </div>
      </Card>
    );
  }

  if (!timeline || timeline.length === 0) {
    return (
      <Card>
        <h2 className="card-title">Timeline (Last 30 Days)</h2>
        <div style={{ padding: 'var(--spacing-lg)', textAlign: 'center', color: 'var(--text-secondary)' }}>
          No timeline data available yet.
        </div>
      </Card>
    );
  }

  // Format data for chart
  const chartData = timeline.map(item => ({
    date: new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    sent: item.messages_sent,
    replies: item.replies,
    seen: item.seen,
    engaged: item.engaged,
    replyRate: item.reply_rate
  }));

  return (
    <Card>
      <h2 className="card-title">Timeline (Last 30 Days)</h2>
      <div style={{ width: '100%', height: 400 }}>
        <ResponsiveContainer>
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border-color)" />
            <XAxis 
              dataKey="date" 
              stroke="var(--text-secondary)"
              style={{ fontSize: 'var(--font-size-xs)' }}
            />
            <YAxis 
              stroke="var(--text-secondary)"
              style={{ fontSize: 'var(--font-size-xs)' }}
            />
            <Tooltip 
              contentStyle={{ 
                background: 'var(--bg-primary)', 
                border: '1px solid var(--border-color)',
                borderRadius: 'var(--border-radius)'
              }}
            />
            <Legend 
              wrapperStyle={{ 
                fontSize: 'var(--font-size-sm)',
                paddingTop: 'var(--spacing-md)'
              }}
            />
            <Line 
              type="monotone" 
              dataKey="sent" 
              stroke="var(--primary)" 
              name="Messages Sent"
              strokeWidth={2}
              dot={{ r: 3 }}
            />
            <Line 
              type="monotone" 
              dataKey="replies" 
              stroke="var(--success)" 
              name="Replies"
              strokeWidth={2}
              dot={{ r: 3 }}
            />
            <Line 
              type="monotone" 
              dataKey="seen" 
              stroke="var(--info)" 
              name="Seen"
              strokeWidth={1}
              strokeDasharray="5 5"
              dot={{ r: 2 }}
            />
            <Line 
              type="monotone" 
              dataKey="engaged" 
              stroke="var(--warning)" 
              name="Engaged"
              strokeWidth={1}
              strokeDasharray="5 5"
              dot={{ r: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
